import React from 'react';
import PropTypes from 'prop-types';
import ClearIcon from '@mui/icons-material/Clear';
import { getVideoId, getHashParameter } from 'helpers';
import { IconButton, InputAdornment } from '@mui/material';
import TextField from '@atoms/TextField';
import { useTranslation } from '../../../../config/i18n';
import { VideoContainer, CloseBtn, useClasses } from './style';
import Image from '../../../atoms/Image'

// const getHeight = (width) => (width * 45) / 80;

const VideoItem = ({ onChange, index, value, onRemoveClick, width, height, onLinkAdded, onedit }) => {
  const { t } = useTranslation(['applications', 'common', 'opportunity']);

  const [localVal, setLocalVal] = React.useState(false);

  const classes = useClasses();

  const onChangeHandler = (e) => {
    const link = e.target.value;
    const videoId = getVideoId(link);
    if (videoId) {
      onChange(link, index);
      setLocalVal(false);
    } else {
      setLocalVal(true);
    }
    onLinkAdded()
  };
  const handleMouseDownRemove = (event) => {
    event.preventDefault();
  };

  const removeClickHandler = () => {
    onRemoveClick(index);
    onLinkAdded()
  };

  let parsedValue = null;
  if (value) {
    const videoId = getVideoId(value);
    if (videoId && videoId.type === 'YOUTUBE') {
      parsedValue = (
        <iframe
          className={classes.video}
          title={videoId.value}
          width={width}
          height={height}
          src={`https://www.youtube.com/embed/${videoId.value}`}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      );
    } else if (videoId && videoId.type === 'VIMEO') {
      const hashParameter = getHashParameter(value);
      parsedValue = (
        <iframe
          title={videoId.value}
          src={`https://player.vimeo.com/video/${videoId.value}?h=${hashParameter}`}
          width={width}
          height={height}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        />
      );
    } else {
      parsedValue = (
        <iframe
          className={classes.video}
          title="video"
          width={width}
          height={height}
          src={value}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      );
    }
  }

  return (
    <>
      <VideoContainer fullWidth={!parsedValue} className="video-item">
        {parsedValue || (
          <TextField
            className="video-input"
            label={t('opportunity:link_to_video')}
            {...(localVal && { helperText: t('couldnot_extract_video'), error: true })}
            onChange={onChangeHandler}
            placeholder="Link to video"
            // value={localVal}
            // error={Boolean(value && !parsedValue)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="remove video item"
                    onClick={removeClickHandler}
                    onMouseDown={handleMouseDownRemove}
                    edge="end"
                  >
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ),
              startAdornment: (
                <InputAdornment position="start">
                  <Image
                    src="/images/icons/add_video.svg"
                    width="24px"
                    height="24px"
                    color="secondary"
                  />
                </InputAdornment>
              ),
            }}
          />
        )}
        {onedit && onRemoveClick && parsedValue && (
          <CloseBtn size="small" color="primary" aria-label="Remove" onClick={removeClickHandler}>
            <ClearIcon />
          </CloseBtn>
        )}
      </VideoContainer>
    </>
  );
};

VideoItem.propTypes = {
  onChange: PropTypes.func,
  onRemoveClick: PropTypes.func,
  onLinkAdded: PropTypes.func,
  width: PropTypes.number,
  height: PropTypes.number,
  index: PropTypes.number,
  value: PropTypes.string,
  onedit: PropTypes.bool,
};

VideoItem.defaultProps = {
  width: 400,
  height: 350,
  onChange: () => { },
  onRemoveClick: () => { },
  onLinkAdded: () => { },
  index: 0,
  value: "",
  onedit: false,
};

export default VideoItem;
